// extracted by mini-css-extract-plugin
export default {"tabHeadItem":"rvdi0","test":"pe7yL","extended":"jQTDO","quiz":"ZDqOh","poll":"fKmpF","crossword":"VP_p1","label":"DaD_J","testCount":"LjBQ1"};